module.exports = __webpack_public_path__ + "static/business-icon-4e05871b102572ab9d304238ede89703.png";